import type { RivalType } from 'api/api.types';
import type { ArrayValues } from 'type-fest';

export type CreateRivalReturnType = Omit<RivalType, 'profile'> & {
  profile: { id: number };
  statusId: string;
}; // TODO RivalType needs work, it's not correct / depends on params
export type CreateRivalQueryType = {
  category: 'company' | 'product' | 'other';
  imageUrl?: string;
  copyFromId?: number;
  name: string;
  url?: string;
  withMetabaseSubscription?: boolean;
};

export type FetchRivalsQueryType = {
  minimal?: boolean;
  page: number;
  limit: number;
  icon?: boolean;
  cardsCount?: boolean;
  visibilityGroupId?: number;
  rivalGroupId?: number;
  order?: DashboardSortType;
  spiderStatus?: boolean;
  v?: number;
};

export type FetchRivalsReturnType = {
  totalItems: number;
  items: RivalType[];
};

export type FetchRivalGroupsQueryType = {
  visibilityGroupId?: number;
};

export const DASHBOARD_SORT_OPTIONS = [
  'battlecards',
  'cards',
  'created',
  'created-rev',
  'alpha',
  'alpha-rev',
] as const;

export const DASHBOARD_SORT_LIMITED_OPTIONS = [
  'created',
  'created-rev',
  'alpha',
  'alpha-rev',
] as const;

export type DashboardSortType = ArrayValues<typeof DASHBOARD_SORT_OPTIONS>;

export type RivalWithSupportedRivalType = RivalType & {
  supportedRivalId: number;
  supportedRivalName?: string;
};
